export default function RedoIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 96 960 960"
    >
      <path
        fill="currentColor"
        d="M389.739 865.609q-98.693 0-170.151-66.985Q148.13 731.638 148.13 634q0-97.638 71.458-164.624 71.458-66.985 170.151-66.985h270.825l-76.608-76.608Q572.13 313.957 572.13 298t11.826-27.783q11.826-11.826 27.783-11.826t27.783 11.826l144 144q6.13 6.221 9.261 13.211 3.13 6.989 3.13 14.617 0 7.628-3.13 14.618-3.131 6.989-9.261 13.12l-144 144q-11.826 11.826-27.783 11.826t-27.783-11.826Q572.13 601.957 572.13 586t11.826-27.783l76.608-76.608H388.739q-66.054 0-113.44 43.674Q227.913 568.957 227.913 634t47.386 108.717q47.386 43.674 113.44 43.674h259q16.886 0 28.53 11.326 11.644 11.326 11.644 28.283t-11.644 28.283q-11.644 11.326-28.53 11.326h-258Z"
      />
    </svg>
  );
}
